module.exports = __webpack_public_path__ + "img/Vector.e1a75bbb.svg";